import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk'
import {reducer as questionReducer} from '../entry_app/question_box/';
import {reducer as questionManage} from '../entry_app/question_manage/';
import {reducer as userReducer} from '../entry_app/';
import {reducer as knowledgeAssist} from '../entry_app/knowledge_assist';
import questionPackage from '@/entry_app/question_package/reducer';

import Perf from 'react-addons-perf';

const win = window;

export const appReducer = combineReducers({
    questionBox: questionReducer,
    user:userReducer,
    questionManage:questionManage,
    knowledgeAssist:knowledgeAssist,
    questionPackage
});

const middlewares = [thunkMiddleware];
let storeEnhancers;
if (process.env.NODE_ENV !== 'production') {
    win.Perf = Perf
    storeEnhancers = compose(
        applyMiddleware(...middlewares),
        (win && win.devToolsExtension) ? win.devToolsExtension() : (f) => f,
    );
}else{
    storeEnhancers = compose(
        applyMiddleware(...middlewares),
    );
}
const initialState = {
}

export default createStore(appReducer, initialState, storeEnhancers);




// WEBPACK FOOTER //
// ./src/store/app.js